import Vue from 'vue'
import Router from 'vue-router'
import router from '../router'
import {Base64} from 'js-base64'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default {
  toJump(url) {
    router.push(url);
  },
  goDetail(item) {
    router.push({
      path: '/goodsDetail',
      query: {
        id: item.id
      }
    })
  },
}

const addkey = (name) => {
  let salting = 'admin-authority'
  return Base64.encode(name + salting)
}

const delkey = (name) => {
  let salting = 'admin-authority'
  let decodeName = Base64.decode(name) || ''
  if (decodeName && decodeName.split && decodeName.split(salting) && decodeName.split(salting)[0]) {
    return decodeName.split(salting)[0]
  } else {
    return ''
  }
}

export {
  addkey,
  delkey
}



// WEBPACK FOOTER //
// ./src/utils/tool.js